export const UPDATED_GLOBAL_SUCCESS_MESSAGE = "UPDATED_GLOBAL_SUCCESS_MESSAGE";
export const REMOVE_GLOBAL_SUCCESS_MESSAGE_IF_MATCHES_THIS_STRING =
  "REMOVE_GLOBAL_SUCCESS_MESSAGE_IF_MATCHES_THIS_STRING";

export const updateGlobalSuccessMessage = successData => {
  return {
    type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
    data: successData
  };
};

export const removeGlobalSuccessMessageIfMatchesThisString = messageString => {
  return {
    type: REMOVE_GLOBAL_SUCCESS_MESSAGE_IF_MATCHES_THIS_STRING,
    data: messageString
  };
};
